import { ReactNode } from 'react';

import { Box, SxProps } from '@mui/material';

export interface BbarProps {
    children?: ReactNode;
    sx?: SxProps;
}

export function Bbar({ children, sx }: BbarProps) {
    return (
        <Box
            sx={{
                zIndex: 10,
                bottom: 0,
                position: 'sticky',
                width: '100vw',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: { xs: 'stretch', md: 'center' },
                flexDirection: { xs: 'column', md: 'row' },
                mt: 'auto',
                ml: 'calc(50% - 50vw)',
                mb: -3,
                py: 1.5,
                px: 'max(16px, calc((100vw - 1400px) / 2 + 16px))',
                gap: 1.5,
                borderTop: 1,
                borderTopColor: 'divider',
                backgroundColor: 'common.white',
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
